function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.602 6.5V5.9H16.002H7.49676C7.27666 5.9 7.09791 5.72218 7.09676 5.50208L7.08374 3.00208C7.08259 2.78036 7.26201 2.6 7.48374 2.6H19.3916C19.6125 2.6 19.7916 2.77909 19.7916 3V17.5168C19.7916 17.7385 19.6113 17.9179 19.3896 17.9168L17 17.9049C16.7798 17.9038 16.602 17.7251 16.602 17.5049V6.5Z",
  stroke: "#00BB77",
  strokeWidth: 1.2
});
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4.3,
  y: 5.9,
  width: 12.3,
  height: 15.5217,
  rx: 1,
  stroke: "#00BB77",
  strokeWidth: 1.2
});
const SvgCopyIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopyIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copy-icon.f7f3fe80.svg";
export { ForwardRef as ReactComponent };